import Alert from '@components/v2/ui/Alert/Alert';
import LangEnum from '../../../lang/LangEnum';

const UpdateConditionsAndPricesWarning = () => (
  <Alert
    title={LangEnum.GLOBAL_UPDATE_IS_IRREVERSIBLE}
    message={LangEnum.ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_WARNING}
  />
);

export default UpdateConditionsAndPricesWarning;
